import _ from 'underscore';
import { ToolConfig, ToolsDialogConfig } from './types';

const itemMatchesSearchValue = (item: ToolConfig, searchValue: string): boolean => {
  const nameMatches = item.name.toLowerCase().includes(searchValue.toLowerCase());
  const descriptionMatches = item.description.toLowerCase().includes(searchValue.toLowerCase());

  return nameMatches || descriptionMatches;
};

export const getFilteredConfig = (config: ToolsDialogConfig, searchValue: string): ToolsDialogConfig => {
  const filteredGroups = config.groups.map((group) => ({
    ...group,
    items: group.items.filter((tool) => itemMatchesSearchValue(tool, searchValue)),
  }));

  const nonEmptyGroups = filteredGroups.filter((group) => group.items.length > 0);

  return {
    ...config,
    groups: nonEmptyGroups,
  };
};

export const areConfigsGroupsTheSame = (config1: ToolsDialogConfig, config2: ToolsDialogConfig): boolean => {
  const config1GroupKeys = _.chain(config1)
    .get('groups', [])
    .map((group) => group.key)
    .value();
  const config2GroupKeys = _.chain(config2)
    .get('groups', [])
    .map((group) => group.key)
    .value();

  return _.chain(config1GroupKeys)
    .zip(config2GroupKeys)
    .all(([key1, key2]) => key1 === key2)
    .value();
};

export const getResultsCount = (config: ToolsDialogConfig): number => config.groups.reduce((prev, curr) => prev + curr.items.length, 0);
